import { TemplateService } from '../../services/template.service';
import { Chart } from 'chart.js';
import * as _ from 'lodash';
import { ApiService } from '../../services/api.service';
import { SubSink } from 'subsink';
import { HttpParams } from "@angular/common/http";
import { TranslateService } from "@ngx-translate/core";
import * as moment from "moment";
import { CALENDAR_LOCALE } from "../../services/constant";
// import {el} from "@angular/platform-browser/checkdateing/src/browser_util";
var EmailDashboardComponent = (function () {
    function EmailDashboardComponent(apiService, translate, template) {
        this.apiService = apiService;
        this.translate = translate;
        this.template = template;
        this.subs = new SubSink();
        this.currentPage = 1;
        this.itemsPerPage = 40;
        this.totalItems = 0;
        this.loading_main = false;
        this.datastatus = [];
        this.selectedCompany = null;
        this.branchList = null;
        this.selectedBranch = null;
        this.allDeliverycodeList = [];
        this.allBranchList = null;
        this.startDate = null;
        this.endDate = null;
        this.calendarLocale = CALENDAR_LOCALE.TH;
        this.allBranchSelected = [];
        this.sortBy = null;
        this.checkdate = null;
        this.sortMode = null;
        this.defaultLabel = null;
        this.sentdata = null;
    }
    EmailDashboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadData();
        this.translate.onLangChange.subscribe(function (event) {
            _this.getEmailReport();
        });
        this.getEmailReport();
    };
    EmailDashboardComponent.prototype.getEmailReport = function () {
        var _this = this;
        if (this.translate.currentLang === 'en') {
            this.calendarLocale = CALENDAR_LOCALE.EN;
        }
        else {
            this.calendarLocale = CALENDAR_LOCALE.TH;
        }
        this.rdDocumentType = this.template.getDropdown();
        this.selectedCompany = null;
        this.company = null;
        this.selectedRdDocumentType = null;
        this.company = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        this.branchList = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        this.loading_main = true;
        this.data = this.apiService.getEmailReport().subscribe(function (res) {
            _this.emailTotal = res.transactions_sent + res.transactions_failed;
            _this.transactions_sent = res.transactions_sent;
            _this.transactions_failed = res.transactions_failed;
            _this.transactions_wait_for_send = res.transactions_wait_for_send;
            _this.transactions_not_sent = res.transactions_not_sent;
            _this.loading_main = false;
            _this.generateChart();
            _this.getTreeTableValue();
            _.forEach(res.results, function (obj) {
                _this.company.push({
                    label: obj.customer_code,
                    value: obj.customer_code
                });
                _this.allDeliverycodeList.push({
                    label: obj.delivery_code,
                    value: obj.customer_code
                });
            });
            _this.company = _.uniqBy(_this.company, 'label');
            _this.filterDeliverycodeList();
        });
        this.loading_main = false;
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
    };
    EmailDashboardComponent.prototype.getTreeTableValue = function () {
        this.treeTableValue = {
            'data': [
                {
                    'data': {
                        'name': 'Documents',
                        'size': '75kb',
                        'type': 'Folder'
                    },
                    'children': [
                        {
                            'data': {
                                'name': 'Work',
                                'size': '55kb',
                                'type': 'Folder'
                            },
                            'children': [
                                {
                                    'data': {
                                        'name': 'Expenses.doc',
                                        'size': '30kb',
                                        'type': 'Document'
                                    }
                                },
                                {
                                    'data': {
                                        'name': 'Resume.doc',
                                        'size': '25kb',
                                        'type': 'Resume'
                                    }
                                }
                            ]
                        },
                        {
                            'data': {
                                'name': 'Home',
                                'size': '20kb',
                                'type': 'Folder'
                            },
                            'children': [
                                {
                                    'data': {
                                        'name': 'Invoices',
                                        'size': '20kb',
                                        'type': 'Text'
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    'data': {
                        'name': 'Pictures',
                        'size': '150kb',
                        'type': 'Folder'
                    },
                    'children': [
                        {
                            'data': {
                                'name': 'barcelona.jpg',
                                'size': '90kb',
                                'type': 'Picture'
                            }
                        },
                        {
                            'data': {
                                'name': 'primeui.png',
                                'size': '30kb',
                                'type': 'Picture'
                            }
                        },
                        {
                            'data': {
                                'name': 'optimus.jpg',
                                'size': '30kb',
                                'type': 'Picture'
                            }
                        }
                    ]
                }
            ]
        };
    };
    EmailDashboardComponent.prototype.generateChart = function () {
        var keepchart = this.transactions_sent + this.transactions_failed;
        this.sentChart = new Chart('sentChart', {
            type: 'doughnut',
            data: {
                // labels: ['Red', 'Blue', 'Yellow'],
                datasets: [{
                        label: 'Sent Chart',
                        data: [this.transactions_sent],
                        backgroundColor: [
                            '#00FF00',
                            '#5b5a5a',
                        ],
                        borderColor: [
                            '#ededed',
                            '#ededed',
                        ],
                        borderWidth: 1
                    }]
            },
            options: {
                responsive: true,
                tooltips: {
                    enabled: false,
                },
                cutoutPercentage: 60
            }
        });
        this.errorChart = new Chart('errorChart', {
            type: 'doughnut',
            data: {
                // labels: ['Red', 'Blue', 'Yellow'],
                datasets: [{
                        label: '# of Votes',
                        data: [this.transactions_failed, keepchart],
                        backgroundColor: [
                            '#cc0000',
                            '#6F6E6E'
                        ],
                        borderColor: [
                            '#ededed',
                            '#ededed',
                        ],
                        borderWidth: 1
                    }]
            },
            options: {
                tooltips: {
                    enabled: false,
                },
                cutoutPercentage: 60
            }
        });
    };
    EmailDashboardComponent.prototype.pageChanged = function () {
        this.sentdata = 1;
        this.loadData(this.currentPage);
    };
    EmailDashboardComponent.prototype.setPageSide = function () {
    };
    EmailDashboardComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    EmailDashboardComponent.prototype.searchButtonClicked = function () {
        this.currentPage = 1;
        this.sortBy = null;
        this.sortMode = null;
        this.loadData();
    };
    EmailDashboardComponent.prototype.sentdate = function () {
        this.checkdate = 1;
    };
    EmailDashboardComponent.prototype.loadData = function (page, data) {
        var _this = this;
        this.datastatus = [];
        this.loading_main = true;
        this.selectedCompany = null;
        this.company = null;
        this.company = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        this.apiService.getCompany().subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.company.push({
                    label: obj.name,
                    value: obj.id
                });
            });
            _this.company = _.uniqBy(_this.company, 'label');
        }, function (error) { return error(status); });
        this.apiService.getBranch().subscribe(function (result) {
            _this.allBranchList = result;
            _this.filterBranchList();
        });
        var keepstartDate = moment(this.startDate).format('YYYY-MM-DD');
        var keependDate = moment(this.endDate).format('YYYY-MM-DD');
        var params = new HttpParams();
        if (this.selectedCompany && this.selectedRdDocumentType) {
            params = params.append('customer_code', this.selectedCompany);
            params = params.append('document_type', this.selectedRdDocumentType);
        }
        if (data) {
            params = params.append('status', data);
        }
        if (this.selectedCompany) {
            params = params.append('customer_code', this.selectedCompany);
        }
        if (this.selectedRdDocumentType) {
            params = params.append('document_type', this.selectedRdDocumentType);
        }
        if (this.email) {
            params = params.append('email', this.email);
        }
        if (this.selectedBranch) {
            params = params.append('customer_code', this.selectedBranch);
        }
        // else if(keepstartDate)
        if (this.checkdate == 1) {
            params = params.append('document_date_gte', keepstartDate);
            params = params.append('document_date_lte', keependDate);
        }
        if (this.sentdata) {
            params = params.append('page', this.currentPage.toString());
            params = params.append('page_size', this.itemsPerPage.toString());
        }
        this.apiService.getEmailDashboard(params).subscribe(function (result) {
            _.forEach(result.results, function (obj) {
                _this.totalItems = result.count;
                _this.datastatus.push({
                    email_data: obj.email_data.emails,
                    cc_email_data: obj.email_data.cc_list,
                    document_date: obj.document_date,
                    customer_code: obj.customer_code,
                    delivery_code: obj.delivery_code,
                    document_number: obj.document_number,
                    document_type: obj.document_type,
                    tax_data: obj.tax_data,
                    status: obj.status
                });
            });
            _this.loading_main = false;
        });
        this.loading_main = false;
    };
    Object.defineProperty(EmailDashboardComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = (new Date()).getFullYear();
            return (thisYear - 40) + ':' + thisYear;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmailDashboardComponent.prototype, "dateRange", {
        get: function () {
            if (!this.startDate && !this.endDate) {
                return null;
            }
            var start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
            var end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    EmailDashboardComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
    };
    EmailDashboardComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
    };
    EmailDashboardComponent.prototype.clearData = function () {
        this.transactions_failed = null;
        this.transactions_wait_for_send = null;
        this.transactions_not_sent = null;
        this.transactions_sent = null;
        this.datastatus = null;
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.rdDocumentType = null;
        this.branchList = null;
        this.company = null;
        this.email = null;
        this.startDate = null;
        this.endDate = new Date();
        this.startDate = new Date();
        this.sortBy = null;
        this.sortMode = null;
        this.totalItems = 0;
        this.checkdate = null;
        this.currentPage = 1;
        this.selectedBranch = null;
        this.getEmailReport();
        this.loadData();
    };
    EmailDashboardComponent.prototype.filterDeliverycodeList = function () {
        var _this = this;
        this.selectedBranch = null;
        _.forEach(this.allDeliverycodeList, function (obj) {
            if (_this.selectedCompany == null || obj.value == _this.selectedCompany)
                _this.branchList.push({
                    label: obj.label,
                    value: obj.value
                });
        });
    };
    ;
    EmailDashboardComponent.prototype.filterBranchList = function () {
        var _this = this;
        this.selectedBranch = null;
        this.branchList = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        _.forEach(this.allBranchList, function (obj) {
            if (_this.selectedCompany == null || obj.corporate == _this.selectedCompany)
                _this.branchList.push({
                    label: obj.full_name,
                    value: obj.id
                });
        });
    };
    ;
    EmailDashboardComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    return EmailDashboardComponent;
}());
export { EmailDashboardComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/email-dashboard/email-dashboard.component.ts.pre-build-optimizer.js